// extracted by mini-css-extract-plugin
export default {"container":"OpenLinkNewWindow_container__MY2VJ","content":"OpenLinkNewWindow_content__ExwVt","link":"OpenLinkNewWindow_link__Zly8B","colorIcon":"OpenLinkNewWindow_colorIcon__rAS6Q"};